import React, {Component} from 'react';
import {connect} from 'react-redux'
import $ from 'jquery'
import {SyncConfig} from '../OfflineDb/ConfigDataSync';
import {SelectSettings} from '../OfflineDb/IndexDbTranscSP'


const mapStateToProps = (Store) => {
    return Store
}

const mapDispatchToProps = (dispatch) => {
    return {
        ShowAlert: (Settings) => {
            dispatch({type: "UpdateAlert", payload: Settings})
        },
        UpdateConfiguration: (data, type) => {
            dispatch({type: type, payload: {data}})
        },
    }
}

class Landing extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (

            <div>
                <div className="PageLoder"><i class=" fa fa-circle-o-notch fa-spin"></i>
                    <div style={{fontSize: "18px", minWidth: "275px"}}>Preparing your data. Please wait...</div>
                </div>
            </div>

        );
    }

    componentDidMount = () => {
        if (this.props.UserAuthentication.AuthToken != "") {
            SyncConfig(() => {
                this.UpdateConfigurationStore()
                this.props.history.push("/Home")
            }, () => {
                this.props.ShowAlert({
                    Type: 0,
                    Msg: "Semething went wrong, please check your internet connectivity and login again"
                })
                setTimeout(function () {
                    $("#Alertmsgbtn").click()
                }, 50);
                this.props.history.push("/Login")
            })
        } else {
            localStorage.clear()
            this.props.history.push("/")
        }
    }

    UpdateConfigurationStore = () => {
        SelectSettings((data) => {
            this.props.UpdateConfiguration(data, "UpdateSystemSetting")
        }, (error) => {
        })
    }

}


export default connect(mapStateToProps, mapDispatchToProps)(Landing);


